import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nw-wild-card',
  templateUrl: './wild-card.component.html',
  styleUrls: ['./wild-card.component.scss']
})
export class WildCardComponent implements OnInit {

  public title: string;
  public lead: string;

  constructor() {
    this.title = 'Page Not Found';
    this.lead = 'Looks like we\'ve stuck in error';
  }

  ngOnInit(): void {}

}
